import React__default, { useRef } from 'react';
import classNames from 'classnames';
import styles from './Caret.module.esm.js';

function shortestRotation(prevRotation, targetRotation) {
    var delta = ((((targetRotation - prevRotation) % 360) + 540) % 360) - 180;
    return prevRotation + delta;
}
var Caret = function (_a) {
    var direction = _a.direction, ariaHidden = _a["aria-hidden"];
    var previousRotation = useRef(0);
    var targetRotation = {
        down: 0,
        left: 90,
        right: 270,
        up: 180,
    }[direction];
    var rotation = shortestRotation(previousRotation.current, targetRotation);
    previousRotation.current = rotation;
    return (React__default.createElement("div", { "aria-hidden": ariaHidden, className: classNames(styles.caret), style: { transform: "rotate(".concat(rotation, "deg)") } },
        React__default.createElement("svg", { fill: "none", height: "5", viewBox: "0 0 10 5", width: "10", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M0.106952 0.647321L0.160428 0.703125L4.41176 4.77679C4.55882 4.91071 4.77273 5 5.01337 5C5.25401 5 5.46791 4.91071 5.61497 4.77679L9.85294 0.703125L9.91979 0.636161C9.97326 0.569196 10 0.491071 10 0.412946C10 0.189732 9.77273 0 9.47861 0H0.52139C0.240642 0 0 0.189732 0 0.412946C0.013369 0.502232 0.0534759 0.580357 0.106952 0.647321Z", fill: "currentColor" }))));
};

export { Caret, Caret as default };
//# sourceMappingURL=Caret.esm.js.map
